import { defineComponent } from 'vue';
import { pushGtmEvent } from '@/utils/gtmUtils';

export { GtmEventName } from '@/utils/gtmUtils';

/**
 * This does not actually need to be a mixin anymore, due to changes in the requirements.
 * But I'm not changing it now because of lack of time :/
 */
export default defineComponent({
    name: 'GtmMixin',
    methods: {
        pushGtmEvent,
    },
});
